import React from "react";
import App from "../Layouts/AppLayout";
import Contact from "../Components/PageSections/Contact";
import { Section } from "../Components";
import { FAQContent } from "../Components/PageSections/FAQ";

export default function Help() {

  const [faqs, setFaqs] = React.useState([]);

  React.useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/help-center-data/all');
        const data = await response.json();
        setFaqs(data);
      } catch (e) {}
    };

    fetchFaqs();
  }, []);

  const faqsList = [
    {title: "General FAQ", data: faqs['general']},
    {title: "FAQ by Sellers", data: faqs['seller']},
    {title: "FAQ by Buyers", data: faqs['buyer']},
    {title: "FAQ about SecurePay", data: faqs['securepay']},
  ]

  return (
    <App>
      <Section pad={false} className="tw-pt-8 md:tw-pt-16 lg:tw-pt-20">
        <h1 className="tw-text-center">Frequently Asked Questions</h1>
      </Section>

      {faqsList.map((faq, index) => (
        <Section key={index} className="tw-grid md:tw-grid-cols-4">
          <div className="md:tw-col-span-1">
            <h3 className="tw-text-black">{faq.title}</h3>
          </div>

          <div className="md:tw-col-span-3 tw-flex tw-flex-col tw-items-center">
            <FAQContent questions={faq.data} onHelpPage={true} />
          </div>
        </Section>
      ))}

      <Contact />
    </App>
  );
}
